import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <div className="container py-5">Chargement…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
